import React from "react";
import styles from "./FacebookInt.module.css";
import { FaFacebookF } from "react-icons/fa";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import schoolLogo from "../../assets/images/schoolLogo.png"; // ✅ Update path if needed
import CopyRight from "../../components/CopyRight/CopyRight";

const FacebookInt = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.iconsRow}>
            <FaFacebookF className={styles.iconFacebook} />
            <FaArrowRightArrowLeft className={styles.iconArrow} />
            <img
              src={schoolLogo}
              alt="School Logo"
              className={styles.iconSchool}
            />
          </div>
          <p className={styles.description}>
            Integrate with Facebook for Configure Facebook Enquiry Ad Forms
          </p>
          <button className={styles.connectButton}>
            Connect With Facebook
          </button>
        </div>
      </div>
      <div className={styles.footer}>
        
        <CopyRight />
      </div>
    </div>
  );
};

export default FacebookInt;
